import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { logOut } from '../../actions/index';

const Logout = (props) => {

    const history = useHistory();

    useEffect(() => {
        props.logOut();
        history.push('/login');
    }, [])

    return (
        <>
        </>
    );

};

const mapStateToProps = (state) => {
    return {};
}

export default connect(mapStateToProps, {
    logOut
})(Logout);